const JOB_CARD_SELECTOR = '.job-card';
const EXPLORE_ROLES_JOB_CARD_SELECTOR = '.explore-roles-sec .job-card';
const AUTO_MIN_HEIGHT_JOB_CARD_SELECTOR = '.explore-roles-sec .job-card, .related-vacancies-sec .job-card, .result-jobs-type .job-card, #search_results_box .job-card';
const RELATED_VACANCIES_JOB_CARD_SELECTOR = '.related-vacancies-sec .job-card';

function getJobCards() {
  return Array.from(document.querySelectorAll(JOB_CARD_SELECTOR));
}

function getExploreRolesJobCards() {
  return Array.from(document.querySelectorAll(EXPLORE_ROLES_JOB_CARD_SELECTOR));
}

function getAutoMinHeightJobCards() {
  return Array.from(document.querySelectorAll(AUTO_MIN_HEIGHT_JOB_CARD_SELECTOR));
}

function getRelatedVacanciesJobCards() {
  return Array.from(document.querySelectorAll(RELATED_VACANCIES_JOB_CARD_SELECTOR));
}

function hasAutoMinHeightJobCardContext(jobCard) {
  if (!jobCard) return false;

  return Boolean(
    jobCard.closest('.explore-roles-sec')
    || jobCard.closest('.related-vacancies-sec')
    || jobCard.closest('.result-jobs-type')
    || jobCard.closest('#search_results_box')
  );
}

function hasFixedHeightJobCardContext(jobCard) {
  if (!jobCard) return false;

  return Boolean(jobCard.closest('.related-vacancies-sec'));
}

function getJobCardFixedHeightTargets(jobCard) {
  if (!jobCard) return [];

  const targets = [jobCard];

  if (hasFixedHeightJobCardContext(jobCard)) {
    const swiperSlide = jobCard.closest('.swiper-slide');

    if (swiperSlide) {
      targets.push(swiperSlide);
    }
  }

  return targets;
}

function applyFixedHeightToJobCardTargets(jobCard, height) {
  if (!jobCard || !height) return;

  getJobCardFixedHeightTargets(jobCard).forEach((target) => {
    target.style.minHeight = `${height}px`;
    target.style.height = `${height}px`;
  });
}

function getJobCardGroupParent(jobCard) {
  if (!jobCard) return null;

  const swiperParent = jobCard.closest('.swiper');

  if (swiperParent) {
    return swiperParent;
  }

  return jobCard.parentElement || null;
}

function collectJobCardGroups(jobCards = getJobCards()) {
  const groupsMap = new Map();

  jobCards.forEach((jobCard) => {
    const groupParent = getJobCardGroupParent(jobCard);

    if (!groupParent) return;

    if (!groupsMap.has(groupParent)) {
      groupsMap.set(groupParent, {
        parent: groupParent,
        cards: [],
        isSwiperGroup: groupParent.classList.contains('swiper'),
      });
    }

    groupsMap.get(groupParent).cards.push(jobCard);
  });

  return Array.from(groupsMap.values());
}

function getJobCardGroup(jobCard, groups = collectJobCardGroups()) {
  if (!jobCard) return null;

  return groups.find((group) => group.cards.includes(jobCard)) || null;
}

function throttle(callback, delay = 120) {
  let isThrottled = false;
  let pendingArgs = null;

  return (...args) => {
    if (isThrottled) {
      pendingArgs = args;
      return;
    }

    callback(...args);
    isThrottled = true;

    setTimeout(() => {
      isThrottled = false;

      if (pendingArgs) {
        const nextArgs = pendingArgs;
        pendingArgs = null;
        callback(...nextArgs);
      }
    }, delay);
  };
}

function isOnResizeTypeSwiperGroup(group) {
  return Boolean(group?.isSwiperGroup && group.parent?.classList.contains('on-resize-type'));
}

function isSwiperTagsEqualizeGroup(group) {
  if (!group?.isSwiperGroup) {
    return false;
  }

  if (!isOnResizeTypeSwiperGroup(group)) {
    return true;
  }

  return window.innerWidth < 1024;
}

function isNonSwiperTagsEqualizeGroup(group) {
  if (!group) {
    return false;
  }

  if (!group.isSwiperGroup) {
    return true;
  }

  return isOnResizeTypeSwiperGroup(group) && window.innerWidth >= 1024;
}

function updateSwiperGroupJobCardTagsMinHeight(group) {
  if (!isSwiperTagsEqualizeGroup(group)) {
    return;
  }

  const tagsEls = group.cards
    .map((jobCard) => jobCard.querySelector('.job-card__tags'))
    .filter(Boolean);

  if (!tagsEls.length) {
    return;
  }

  tagsEls.forEach((tagsEl) => {
    tagsEl.style.minHeight = '';
  });

  const maxHeight = Math.max(
    ...tagsEls.map((tagsEl) => Math.ceil(tagsEl.getBoundingClientRect().height))
  );

  if (!maxHeight) {
    return;
  }

  tagsEls.forEach((tagsEl) => {
    tagsEl.style.minHeight = `${maxHeight}px`;
  });
}

function getJobCardGroupColumnsCount(group) {
  if (!group?.parent || !group.cards?.length) return 1;

  const computedStyle = window.getComputedStyle(group.parent);

  if (computedStyle.display.includes('grid')) {
    const columns = computedStyle.gridTemplateColumns
      .split(' ')
      .filter((value) => value && value !== 'none');

    if (columns.length) {
      return columns.length;
    }
  }

  const firstCardRect = group.cards[0].getBoundingClientRect();
  const firstRowCards = group.cards.filter((jobCard) => {
    const cardRect = jobCard.getBoundingClientRect();

    return Math.abs(cardRect.top - firstCardRect.top) <= 4;
  });

  return Math.max(firstRowCards.length, 1);
}

function getJobCardGroupRows(group) {
  if (!group?.cards?.length) return [];

  const rows = [];
  const columnsCount = getJobCardGroupColumnsCount(group);
  const sortedCards = [...group.cards].sort((firstCard, secondCard) => {
    const firstRect = firstCard.getBoundingClientRect();
    const secondRect = secondCard.getBoundingClientRect();

    if (Math.abs(firstRect.top - secondRect.top) > 4) {
      return firstRect.top - secondRect.top;
    }

    return firstRect.left - secondRect.left;
  });

  sortedCards.forEach((jobCard) => {
    const cardRect = jobCard.getBoundingClientRect();
    const currentRow = rows[rows.length - 1];

    if (!currentRow) {
      rows.push({ top: cardRect.top, cards: [jobCard] });
      return;
    }

    if (
      Math.abs(currentRow.top - cardRect.top) <= 4
      && currentRow.cards.length < columnsCount
    ) {
      currentRow.cards.push(jobCard);
      return;
    }

    rows.push({ top: cardRect.top, cards: [jobCard] });
  });

  return rows.map((row) => row.cards);
}

function updateNonSwiperGroupJobCardTagsMinHeight(group) {
  if (!isNonSwiperTagsEqualizeGroup(group)) {
    return;
  }

  const tagsEls = group.cards
    .map((jobCard) => jobCard.querySelector('.job-card__tags'))
    .filter(Boolean);

  if (!tagsEls.length) {
    return;
  }

  tagsEls.forEach((tagsEl) => {
    tagsEl.style.minHeight = '';
  });

  const rows = getJobCardGroupRows(group);

  rows.forEach((rowCards) => {
    const rowTagsEls = rowCards
      .map((jobCard) => jobCard.querySelector('.job-card__tags'))
      .filter(Boolean);

    if (!rowTagsEls.length) {
      return;
    }

    const maxHeight = Math.max(
      ...rowTagsEls.map((tagsEl) => Math.ceil(tagsEl.getBoundingClientRect().height))
    );

    if (!maxHeight) {
      return;
    }

    rowTagsEls.forEach((tagsEl) => {
      tagsEl.style.minHeight = `${maxHeight}px`;
    });
  });
}

function updateSwiperJobCardTagsMinHeight(jobCards = getJobCards()) {
  const groups = collectJobCardGroups(jobCards);

  groups.forEach((group) => {
    updateSwiperGroupJobCardTagsMinHeight(group);
  });
}

function updateNonSwiperJobCardTagsMinHeight(jobCards = getJobCards()) {
  const groups = collectJobCardGroups(jobCards);

  groups.forEach((group) => {
    updateNonSwiperGroupJobCardTagsMinHeight(group);
  });
}

window.getJobCardGroupParent = getJobCardGroupParent;
window.collectJobCardGroups = collectJobCardGroups;
window.getJobCardGroup = getJobCardGroup;
window.updateSwiperJobCardTagsMinHeight = updateSwiperJobCardTagsMinHeight;
window.updateNonSwiperJobCardTagsMinHeight = updateNonSwiperJobCardTagsMinHeight;

function setJobCardMeasuredState(jobCard, isHover, preserveTextState = false) {
  const textEl = jobCard.querySelector('.job-card__text');

  jobCard.classList.toggle('is-hover', isHover);

  if (textEl && !preserveTextState) {
    textEl.classList.toggle('is-not-hovered', isHover);
  }
}

function updateJobCardCompactHover(jobCard) {
  if (!jobCard) return;

  if (!hasAutoMinHeightJobCardContext(jobCard)) {
    jobCard.classList.remove('is-compact-hover');
    return;
  }

  const titleEl = jobCard.querySelector('.job-card__title');
  if (!titleEl) return;

  const computedStyle = window.getComputedStyle(titleEl);
  let lineHeight = parseFloat(computedStyle.lineHeight);

  if (!Number.isFinite(lineHeight)) {
    const fontSize = parseFloat(computedStyle.fontSize) || 0;
    lineHeight = fontSize * 1.15;
  }

  if (!lineHeight) return;

  const linesCount = Math.round(titleEl.scrollHeight / lineHeight);

  jobCard.classList.toggle('is-compact-hover', linesCount >= 3);
}

function updateJobCardTextHeights(jobCard) {
  if (!jobCard) return;

  const textEl = jobCard.querySelector('.job-card__text');
  if (!textEl) return;

  const computedStyle = window.getComputedStyle(textEl);
  let lineHeight = parseFloat(computedStyle.lineHeight);
  const fontSize = parseFloat(computedStyle.fontSize) || 0;

  if (!Number.isFinite(lineHeight)) {
    lineHeight = fontSize * 1.1;
  }

  if (!lineHeight) return;

  const safetyOffset = Math.max(Math.ceil(fontSize), 10);

  jobCard.style.setProperty(
    '--job-card-text-max-height-default',
    `${Math.ceil(lineHeight * 3 + safetyOffset)}px`
  );

  jobCard.style.setProperty(
    '--job-card-text-max-height-hover',
    `${Math.ceil(lineHeight * 6 + safetyOffset)}px`
  );

  jobCard.style.setProperty(
    '--job-card-text-max-height-hover-compact',
    `${Math.ceil(lineHeight * 5 + safetyOffset)}px`
  );
}

function updateAutoMinHeightJobCardsCompactHover() {
  getAutoMinHeightJobCards().forEach((jobCard) => {
    updateJobCardCompactHover(jobCard);
    updateJobCardTextHeights(jobCard);
  });
}

function getJobCardAutoHeight(jobCard) {
  return Math.ceil(jobCard.getBoundingClientRect().height);
}

function updateExploreRolesJobCardMinHeight(jobCard) {
  if (!hasAutoMinHeightJobCardContext(jobCard)) return;

  const textEl = jobCard.querySelector('.job-card__text');
  const wasHover = jobCard.classList.contains('is-hover');
  const hadTextHoverState = textEl?.classList.contains('is-not-hovered') ?? false;
  const fixedHeightTargets = getJobCardFixedHeightTargets(jobCard);
  const prevInlineStyles = fixedHeightTargets.map((target) => ({
    target,
    minHeight: target.style.minHeight,
    height: target.style.height,
  }));

  fixedHeightTargets.forEach(({ style }) => {
    style.minHeight = '';
    style.height = 'auto';
  });

  setJobCardMeasuredState(jobCard, false, true);
  if (textEl) {
    textEl.classList.toggle('is-not-hovered', hadTextHoverState);
  }
  const defaultHeight = getJobCardAutoHeight(jobCard);

  setJobCardMeasuredState(jobCard, true);
  const hoverHeight = getJobCardAutoHeight(jobCard);

  jobCard.classList.toggle('is-hover', wasHover);
  if (textEl) {
    textEl.classList.toggle('is-not-hovered', hadTextHoverState);
  }

  const targetHeight = Math.max(defaultHeight, hoverHeight);

  fixedHeightTargets.forEach(({ style }) => {
    style.minHeight = `${targetHeight}px`;
    style.height = `${targetHeight}px`;
  });

  if (!defaultHeight && !hoverHeight) {
    prevInlineStyles.forEach(({ target, minHeight, height }) => {
      target.style.minHeight = minHeight;
      target.style.height = height;
    });
  }
}

function updateAutoMinHeightJobCardsMinHeight() {
  getAutoMinHeightJobCards().forEach((jobCard) => {
    updateExploreRolesJobCardMinHeight(jobCard);
  });
}

function updateAutoMinHeightJobCardsLayout() {
  if (!getAutoMinHeightJobCards().length) return;

  updateAutoMinHeightJobCardsCompactHover();
  updateAutoMinHeightJobCardsMinHeight();
}

function updateRelatedVacanciesJobCardsLayout() {
  const relatedVacanciesJobCardsArr = getRelatedVacanciesJobCards();

  if (!relatedVacanciesJobCardsArr.length) return;

  relatedVacanciesJobCardsArr.forEach((jobCard) => {
    updateJobCardCompactHover(jobCard);
    updateExploreRolesJobCardMinHeight(jobCard);
  });

  const groups = collectJobCardGroups(relatedVacanciesJobCardsArr);

  groups.forEach((group) => {
    if (!group.isSwiperGroup || !group.parent.closest('.related-vacancies-sec')) {
      return;
    }

    const maxHeight = Math.max(
      ...group.cards.map((jobCard) => Math.ceil(jobCard.getBoundingClientRect().height))
    );

    if (!maxHeight) {
      return;
    }

    group.cards.forEach((jobCard) => {
      applyFixedHeightToJobCardTargets(jobCard, maxHeight);
    });
  });
}

function updateJobCardsSharedLayout() {
  updateSwiperJobCardTagsMinHeight();
  updateNonSwiperJobCardTagsMinHeight();
  updateAutoMinHeightJobCardsLayout();
  updateRelatedVacanciesJobCardsLayout();
}

window.updateJobCardsSharedLayout = updateJobCardsSharedLayout;

function initJobCard(jobCard) {
  if (!jobCard || jobCard.classList.contains('is-init-job-card')) {
    return;
  }

  jobCard.classList.add('is-init-job-card');

  updateJobCardCompactHover(jobCard);

  jobCard.addEventListener('mouseenter', () => {
    window.startJobCardHover(jobCard);
  });

  jobCard.addEventListener('mouseleave', () => {
    window.stopJobCardHover(jobCard);
  });

  jobCard.addEventListener('click', () => {
    if (window.innerWidth <= 1032 && !jobCard.closest('.swiper-slide')) {
      if (jobCard.classList.contains('is-hover')) {
        window.stopJobCardHover(jobCard);
      } else {
        window.startJobCardHover(jobCard);
      }
    }
  });
}

function initJobCards(context = document) {
  let root = context;

  if (typeof context === 'string') {
    root = document.querySelector(context);
  }

  if (!root) {
    root = document;
  }

  const queryRoot = root?.querySelectorAll ? root : document;
  const jobCards = queryRoot.matches?.(JOB_CARD_SELECTOR)
    ? [queryRoot]
    : Array.from(queryRoot.querySelectorAll(JOB_CARD_SELECTOR));

  jobCards.forEach((jobCard) => {
    initJobCard(jobCard);
  });

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      updateJobCardsSharedLayout();
    });
  });

  setTimeout(() => {
    updateJobCardsSharedLayout();
  }, 60);
}

window.initJobCards = initJobCards;

if (getJobCards().length) {
  initJobCards();

  const throttledResizeHandler = throttle(() => {
    updateJobCardsSharedLayout();
  }, 120);

  window.addEventListener('resize', throttledResizeHandler);

  window.addEventListener('load', () => {
    updateJobCardsSharedLayout();
  });

  updateJobCardsSharedLayout();

  if (document.fonts?.ready) {
    document.fonts.ready.then(() => {
      updateJobCardsSharedLayout();
    });
  }
}

window.startJobCardHover = function startJobCardHover(jobCard) {
  if (!jobCard) return;

  const textEl = jobCard.querySelector('.job-card__text');

  if (jobCard._hoverRemoveTimer) {
    clearTimeout(jobCard._hoverRemoveTimer);
  }

  jobCard.classList.add('is-hover');
  textEl?.classList.add('is-not-hovered');
}

window.stopJobCardHover = function stopJobCardHover(jobCard) {
  if (!jobCard) return;

  const textEl = jobCard.querySelector('.job-card__text');

  jobCard.classList.remove('is-hover');

  jobCard._hoverRemoveTimer = setTimeout(() => {
    textEl?.classList.remove('is-not-hovered');
  }, 400);
}
